import { Button, Modal } from 'aurorui'
import {Helmet} from 'react-helmet';
import { useState } from 'react';
import React from 'react'
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function ModalScreen() {
    const [modalVisible, setModalVisible] = useState(false);
  return (
   <div className=' screen red-bg'>
    <Helmet>
        <meta charSet="utf-8" />
        <title>Modal</title>
    </Helmet>
      <h1 className="component-name">Modal</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_drawer'>
                <Button 
                    label='Show Modal'
                    onClick={()=>{
                      console.log('hello')
                      setModalVisible(true)
                    }}
                    type={'secondary'}
                    roundedType='small'
                    size='large'
                    variant='filled'
                    disabled={false}
                />
            </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props}/>
      </div>
      <Modal 
        displayModal={modalVisible} 
        borderRadius='medium' 
        position='middle'
        closeModal={()=>{setModalVisible(false)}}
        backgroundColor={'#265'}
      >
        <div
          style={{
            padding: '3rem',
            display:'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
            <p
              style={{
                fontSize: '2rem',
                color: '#fff',
                fontWeight: '700'
              }}
            >This is my modal</p>
            <Button 
              variant='filled'
                label="Close modal" 
                onClick={()=>{setModalVisible(false)}} 
                size={'large'} 
                roundedType={'extralarge'}
                disabled={false}
            />
        </div>
        
      </Modal>
    </div>
  )
}


const props = [
  {
      name: "isOpen",
      required: 'true',
      description: "isDrawerOpen",
      possible_values: " boolean "
  },
  {
    name: "position",
    required: 'true',
    description: "where do you want to place your toast",
    possible_values: " 'middle' 'top-middle' 'bottom-middle' "
  },
  {
    name: "borderRadius",
    required: 'false',
    description: " border radius type of the button",
    possible_values: " 'small' 'medium' 'large' 'none "
  },
  {
    name: "backgroundColor",
    required: 'false',
    description: "background color of the button",
    possible_values: "any hex or rgb value"
  },
  {
      name: "closeModal",
      required: 'true',
      description: "function controlling value of isOpen",
      possible_values: "Function"
  },
  
  {
      name: "backdropColor",
      required: 'true',
      description: "color of backdrop",
      possible_values: "hex rgba rgb values"
  },
]
export default ComponentScreen(ModalScreen)